import { request } from "@umijs/max";
import { OrganizationSearchRequest, SimplifiedOrganizationSearchResponse } from "./model";

export async function searchCompanies(params: OrganizationSearchRequest): Promise<SimplifiedOrganizationSearchResponse> {
  return request('/company/search', {
    method: 'POST',
    data: params,
  });
}
